// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FeedbackModal-cls1___aa13576a41377af697d{/*!*/}.FeedbackModal-cls2___37b049c48b4f934d255{display:flex;flex-direction:column;align-items:center;grid-gap:24px;gap:24px;padding:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "FeedbackModal-cls1___aa13576a41377af697d",
	"cls2": "FeedbackModal-cls2___37b049c48b4f934d255 FeedbackModal-cls1___aa13576a41377af697d"
};
export default ___CSS_LOADER_EXPORT___;
